
import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Style/ParameterOverAir.css";

const SettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="config-icon-ParameterOverAir"
  >
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 0 2.82l-.15.08a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l-.22-.38a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1 0-2.82l.15.08a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const ChevronDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="chevron-down-icon-ParameterOverAir"
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

const SpinnerIcon = () => (
  <svg
    className="spinner-ParameterOverAir"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
      opacity="0.25"
    ></circle>
    <path
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

const StatusMessage = ({ message }) => {
  if (!message.text) return null;
  const typeClasses = {
    info: "status-info-ParameterOverAir",
    success: "status-success-ParameterOverAir",
    error: "status-error-ParameterOverAir",
    warning: "status-warning-ParameterOverAir",
  };
  return (
    <div
      className={`status-message-ParameterOverAir ${typeClasses[message.type]}`}
    >
      {message.text}
    </div>
  );
};

const CustomSelect = ({
  id,
  value,
  onChange,
  children,
  placeholder,
  disabled = false,
}) => (
  <div className="custom-select-wrapper-ParameterOverAir">
    <select
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="custom-select-ParameterOverAir"
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {children}
    </select>
    <div className="custom-select-icon-ParameterOverAir">
      <ChevronDownIcon />
    </div>
  </div>
);

const FormInput = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  unit,
  step,
  error,
  disabled = false,
}) => (
  <div>
    <label htmlFor={name} className="form-input-label-ParameterOverAir">
      {label}
    </label>
    <div className="form-input-wrapper-ParameterOverAir">
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        step={step}
        className={`form-input-ParameterOverAir ${error ? "input-error-ParameterOverAir" : ""}`}
        disabled={disabled}
      />
      {unit && <span className="form-input-unit-ParameterOverAir">{unit}</span>}
    </div>
    {error && (
      <p className="form-input-error-message-ParameterOverAir">{error}</p>
    )}
  </div>
);

const ActionModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmText,
  confirmClass,
}) => {
  if (!isOpen) return null;
  return (
    <div className="modal-backdrop-ParameterOverAir" onClick={onClose}>
      <div
        className="modal-content-ParameterOverAir"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modal-title-ParameterOverAir">{title}</h3>
        <p className="modal-body-ParameterOverAir">{children}</p>
        <div className="modal-actions-ParameterOverAir">
          <button
            onClick={onClose}
            className="button-ParameterOverAir button-gray-ParameterOverAir"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`button-ParameterOverAir ${confirmClass || "button-blue-ParameterOverAir"}`}
          >
            {confirmText || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

const API_BASE_URL = "https://api.yellowmatrix.co.in";

function ParameterOverAir() {
  const [vehicles, setVehicles] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [vehicleData, setVehicleData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ type: "", text: "" });
  const [errors, setErrors] = useState({});
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [assignModalMessage, setAssignModalMessage] = useState("");

  const initialConfigState = {
    primaryIp: "",
    primaryPort: "",
    secondaryIp: "",
    secondaryPort: "",
    apn: "",
    sleepTime: 60,
    overspeedLimit: 80,
    harshBraking: 2,
    harshAcceleration: 2,
    smsCenter: "",
    regNumber: "",
    deviceNumber: "",
    dataTxNormal: 30,
    dataTxIgnitionOff: 600,
    emergencyDuration: 10,
    analogInput1: "",
    analogInput2: "",
  };

  const [config, setConfig] = useState(initialConfigState);

  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/Deviceassociate");
  };
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchCustomers = async () => {
      if (!token) {
        setStatusMessage({
          type: "error",
          text: "Authentication token not found. Please log in.",
        });
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/customers`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error(
            `Failed to fetch customer list (Status: ${response.status})`,
          );
        }

        const data = await response.json();

        if (Array.isArray(data)) {
          setCustomers(data);
        } else {
          throw new Error("Invalid data structure received for customers.");
        }
      } catch (error) {
        setStatusMessage({ type: "error", text: error.message });
        console.error("Fetch customers error:", error);
      }
    };

    fetchCustomers();
  }, [token]);

  useEffect(() => {
    if (!selectedCustomer) {
      setVehicles([]);
      return;
    }

    const fetchVehicles = async () => {
      if (!token) {
        setStatusMessage({
          type: "error",
          text: "Authentication token not found.",
        });
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/vehiclereg/assigned?customer_id=${selectedCustomer}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (!response.ok) {
          throw new Error(
            `Failed to fetch vehicle list (Status: ${response.status})`,
          );
        }

        const data = await response.json();

        if (data.Vehicle && Array.isArray(data.Vehicle)) {
          setVehicles(data.Vehicle);
        } else {
          throw new Error("Invalid data structure received for vehicles.");
        }
      } catch (error) {
        setStatusMessage({ type: "error", text: error.message });
        console.error("Fetch vehicles error:", error);
      }
    };

    fetchVehicles();
  }, [selectedCustomer, token]);

  const handleCustomerChange = (e) => {
    setSelectedCustomer(e.target.value);
    setSelectedVehicle("");
    setVehicleData(null);
    setConfig(initialConfigState);
    setStatusMessage({ type: "", text: "" });
    setErrors({});
  };

  const handleVehicleChange = (e) => {
    setSelectedVehicle(e.target.value);
    setVehicleData(null);
    setConfig(initialConfigState);
    setStatusMessage({ type: "", text: "" });
    setErrors({});
  };

  // (handleGet - unchanged)
  const handleGet = useCallback(() => {
    if (!selectedVehicle) {
      setStatusMessage({
        type: "error",
        text: "Please select a vehicle first.",
      });
      return;
    }
    setIsLoading(true);
    setStatusMessage({ type: "info", text: "Fetching device parameters..." });

    const selectedVehicleData = vehicles.find(
      (d) => d.VehicleNumber === selectedVehicle,
    );

    console.log("Selected Vehicle Data:", selectedVehicleData);
    console.log("Assigned Device:", selectedVehicleData?.Device);

    if (!selectedVehicleData) {
      setStatusMessage({
        type: "error",
        text: "Could not find details for the selected vehicle.",
      });
      setIsLoading(false);
      return;
    }

    setTimeout(() => {
      const mockData = {
        deviceID: selectedVehicleData.UniqueDeviceId || "N/A (Not Assigned)",
        M2MNumber: selectedVehicleData.ICCID || "N/A (Not Assigned)",
        CustomerNumber: "90965432109",
      };

      const mockConfig = {
        primaryIp: "192.168.1.100",
        primaryPort: "8080",
        secondaryIp: "192.168.1.101",
        secondaryPort: "9090",
        apn: "internet",
        sleepTime: 60,
        overspeedLimit: 90,
        harshBraking: 2.5,
        harshAcceleration: 2.2,
        smsCenter: "+919876500000",
        dataTxNormal: 45,
        dataTxIgnitionOff: 500,
        emergencyDuration: 15,
        analogInput1: "",
        analogInput2: "",
        regNumber: selectedVehicleData.VehicleNumber,
        deviceNumber: selectedVehicleData.UniqueDeviceId || "",
      };

      setVehicleData(mockData);
      setConfig(mockConfig);
      setIsLoading(false);
      setStatusMessage({
        type: "success",
        text: "Device parameters loaded successfully!",
      });
      setErrors({});
    }, 1500);
  }, [selectedVehicle, vehicles]);

  const proceedWithAssignment = async () => {
    setIsSetting(true);
    setStatusMessage({
      type: "info",
      text: "Sending update command to device...",
    });

    if (!token) {
      setStatusMessage({
        type: "error",
        text: "Authentication token not found.",
      });
      setIsSetting(false);
      return;
    }

    const payload = {
      customer_id: selectedCustomer,
      device_id: config.deviceNumber,
      vehicle_id: config.regNumber,
      confirm: true,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/parameterUpdate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        if (response.status === 404)
          throw new Error(result.Error || "Device Offline");
        if (response.status === 504)
          throw new Error(result.Error || "No Acknowledgment");
        if (response.status === 403)
          throw new Error(result.Error || "Unauthorized");
        throw new Error(
          result.Error || `Failed with status: ${response.status}`,
        );
      }

      if (result.Status === "Success") {
        setStatusMessage({
          type: "success",
          text: `Successfully updated! ACK: ${JSON.stringify(result.ACK)}`,
        });
        console.log("Update successful, ACK received:", result.ACK);
      } else {
        throw new Error(
          result.Error || "Received an unexpected response from server.",
        );
      }
    } catch (error) {
      setStatusMessage({ type: "error", text: error.message });
      console.error("Parameter update error:", error);
    } finally {
      setIsSetting(false);
    }
  };

  const handleSet = async () => {
    if (!selectedCustomer) {
      setStatusMessage({ type: "error", text: "No customer selected." });
      return;
    }
    if (!vehicleData) {
      setStatusMessage({
        type: "error",
        text: "Please GET parameters first before setting.",
      });
      return;
    }
    if (!config.deviceNumber) {
      setStatusMessage({
        type: "error",
        text: "Device Registration Identity is required.",
      });
      setErrors((prev) => ({
        ...prev,
        deviceNumber: "Device identity is required.",
      }));
      return;
    }
    if (!config.regNumber) {
      setErrors((prev) => ({
        ...prev,
        regNumber: "New Vehicle Registration Number is required.",
      }));
      setStatusMessage({
        type: "error",
        text: "Please provide the new vehicle registration number.",
      });
      return;
    }

    setIsSetting(true);
    setStatusMessage({
      type: "info",
      text: "Checking device assignment status...",
    });

    if (!token) {
      setStatusMessage({
        type: "error",
        text: "Authentication token not found.",
      });
      setIsSetting(false);
      return;
    }

    try {
      const checkResponse = await fetch(`${API_BASE_URL}/device/checkassign`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ device_id: config.deviceNumber }),
      });

      const checkResult = await checkResponse.json();

      if (checkResponse.ok) {
        setStatusMessage({
          type: "info",
          text: "Device is free. Proceeding with assignment...",
        });
        await proceedWithAssignment();
      } else if (checkResponse.status === 409) {
        setAssignModalMessage(
          `${checkResult.Message}. Do you want to force re-assignment to ${config.regNumber}?`,
        );
        setIsAssignModalOpen(true);
        setIsSetting(false);
      } else {
        throw new Error(checkResult.Error || "Failed to check device status.");
      }
    } catch (error) {
      setStatusMessage({ type: "error", text: error.message });
      console.error("Device check error:", error);
      setIsSetting(false);
    }
  };

  const handleClear = () => {
    setConfig(initialConfigState);
    setErrors({});
    setStatusMessage({
      type: "info",
      text: "Form cleared. Load data or enter new values.",
    });
  };

  const handleResetDevice = () => {
    setIsResetModalOpen(false);
    setStatusMessage({ type: "warning", text: "Device reset command sent." });
  };

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setConfig((prev) => ({
      ...prev,
      [name]:
        type === "number" ? (value === "" ? "" : parseFloat(value)) : value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  return (
    <div className="container-ParameterOverAir">
      <header className="header-ParameterOverAir">
        <h1 className="header-title-ParameterOverAir">
          Parameter Over Air Configuration
        </h1>
        <p className="header-subtitle-ParameterOverAir">
          Configure device parameters over the air securely and efficiently.
        </p>
        <hr className="line-ParameterOverAir" width="100%" />
      </header>

      <main className="main-grid-ParameterOverAir">
        <div className="left-column-ParameterOverAir">
          <div className="card-ParameterOverAir">
            <h2 className="card-title-ParameterOverAir">Vehicle Selection</h2>
            <div className="form-group-items-ParameterOverAir">
              <CustomSelect
                id="customer"
                value={selectedCustomer}
                onChange={handleCustomerChange}
                placeholder="Select Customer"
              >
                {customers.map((c) => (
                  <option key={c.CustomerID} value={c.CustomerID}>
                    {c.CustomerName}
                  </option>
                ))}
              </CustomSelect>
              <CustomSelect
                id="vehicle"
                value={selectedVehicle}
                onChange={handleVehicleChange}
                placeholder="Select Vehicle"
                disabled={!selectedCustomer}
              >
                {vehicles.map((v) => (
                  <option key={v.VehicleNumber} value={v.VehicleNumber}>
                    {v.VehicleNumber} {!v.UniqueDeviceId ? "(No Device)" : ""}
                  </option>
                ))}
              </CustomSelect>
            </div>
          </div>

          <div className="card-ParameterOverAir">
            <h2 className="card-title-ParameterOverAir">Actions</h2>
            <div className="actions-group-items-ParameterOverAir">
              <button
                onClick={handleGet}
                disabled={!selectedVehicle || isLoading}
                className="button-ParameterOverAir button-blue-ParameterOverAir"
              >
                {isLoading ? (
                  <>
                    <SpinnerIcon /> Getting Data...
                  </>
                ) : (
                  "GET Parameters"
                )}
              </button>
              <button
                onClick={handleSet}
                disabled={!vehicleData || isSetting}
                className="button-ParameterOverAir button-green-ParameterOverAir"
              >
                {isSetting ? (
                  <>
                    <SpinnerIcon /> Setting...
                  </>
                ) : (
                  "SET Parameters"
                )}
              </button>
              <button
                onClick={handleClear}
                disabled={isLoading || isSetting}
                className="button-ParameterOverAir button-gray-ParameterOverAir"
              >
                Clear Form
              </button>
              <button
                className="button-ParameterOverAir-deviceassociate"
                onClick={handleNavigate}
              >
                Device Associate
              </button>
            </div>
          </div>

          {vehicleData && (
            <div className="card-ParameterOverAir animate-fade-in-ParameterOverAir">
              <h2 className="card-title-ParameterOverAir">Device Details</h2>
              <div className="device-details-content-ParameterOverAir">
                <p>
                  <strong className="device-details-label-ParameterOverAir">
                    Device ID:
                  </strong>{" "}
                  <span className="device-details-imei-ParameterOverAir">
                    {vehicleData.deviceID}
                  </span>
                </p>
                <p>
                  <strong className="device-details-label-ParameterOverAir">
                    SIM / M2M Number:
                  </strong>{" "}
                  <span className="device-details-phone-ParameterOverAir">
                    {vehicleData.M2MNumber}
                  </span>
                </p>
                <p>
                  <strong className="device-details-label-ParameterOverAir">
                    Customer Number:
                  </strong>{" "}
                  <span className="device-details-gsm-ParameterOverAir">
                    {vehicleData.CustomerNumber}
                  </span>
                </p>
              </div>
              <button
                onClick={() => setIsResetModalOpen(true)}
                className="button-ParameterOverAir button-resetdevice-ParameterOverAir"
              >
                Reset Device
              </button>
            </div>
          )}
        </div>

        <div className="right-column-ParameterOverAir card-ParameterOverAir-rightside">
          <div className="config-header-ParameterOverAir">
            <SettingsIcon />
            <h2 className="config-title-ParameterOverAir">
              Configuration Parameters
            </h2>
          </div>

          <StatusMessage message={statusMessage} />

          {!vehicleData && !statusMessage.text && (
            <div className="config-placeholder-ParameterOverAir">
              <p>
                Please select a vehicle and click "GET Parameters" to begin.
              </p>
            </div>
          )}

          {vehicleData && (
            <div className="config-form-container-ParameterOverAir animate-fade-in-ParameterOverAir">
              <div className="config-column-ParameterOverAir">
                <div className="config-section-ParameterOverAir">
                  <h3 className="config-section-title-ParameterOverAir">
                    Vehicle Identity
                  </h3>
                  <FormInput
                    label="Vehicle Registration Number"
                    name="regNumber"
                    value={config.regNumber}
                    onChange={handleInputChange}
                    placeholder="e.g., MH12AB3456"
                    error={errors.regNumber}
                    disabled={true}
                  />
                </div>
                <div className="config-section-ParameterOverAir">
                  <h3 className="config-section-title-ParameterOverAir">
                    Device Identity
                  </h3>
                  <FormInput
                    label="Device Registration Identity"
                    name="deviceNumber"
                    value={config.deviceNumber}
                    onChange={handleInputChange}
                    placeholder="e.g., 002C005B..."
                    error={errors.deviceNumber}
                  />
                </div>
                <div className="config-section-ParameterOverAir-Network">
                  <h3 className="config-section-title-ParameterOverAir">
                    Network
                  </h3>
                  <div className="config-input-grid-ParameterOverAir">
                    <FormInput
                      label="Primary IP"
                      name="primaryIp"
                      value={config.primaryIp}
                      onChange={handleInputChange}
                      placeholder="e.g., 192.168.1.1"
                      error={errors.primaryIp}
                    />
                    <FormInput
                      label="Primary Port"
                      name="primaryPort"
                      type="number"
                      value={config.primaryPort}
                      onChange={handleInputChange}
                      placeholder="e.g., 8080"
                      error={errors.primaryPort}
                    />
                    <FormInput
                      label="Secondary IP"
                      name="secondaryIp"
                      value={config.secondaryIp}
                      onChange={handleInputChange}
                      placeholder="e.g., 192.168.1.2"
                      error={errors.secondaryIp}
                    />
                    <FormInput
                      label="Secondary Port"
                      name="secondaryPort"
                      type="number"
                      value={config.secondaryPort}
                      onChange={handleInputChange}
                      placeholder="e.g., 9090"
                      error={errors.secondaryPort}
                    />
                    <FormInput
                      label="APN"
                      name="apN"
                      value={config.apn}
                      onChange={handleInputChange}
                      placeholder="e.g., internet"
                      error={errors.apn}
                    />
                    <FormInput
                      label="Emergency SMS Centre"
                      name="smsCenter"
                      value={config.smsCenter}
                      onChange={handleInputChange}
                      placeholder="e.g., +91..."
                    />
                  </div>
                </div>
                <div className="config-section-ParameterOverAir-Thresholds">
                  <h3 className="config-section-title-ParameterOverAir">
                    Thresholds & Limits
                  </h3>
                  <div className="config-input-grid-ParameterOverAir">
                    <FormInput
                      label="Overspeed Limit"
                      name="overspeedLimit"
                      type="number"
                      value={config.overspeedLimit}
                      onChange={handleInputChange}
                      unit="km/h"
                    />
                    <FormInput
                      label="Sleep Time"
                      name="sleepTime"
                      type="number"
                      value={config.sleepTime}
                      onChange={handleInputChange}
                      unit="seconds"
                    />
                    <FormInput
                      label="Harsh Braking Threshold"
                      name="harshBraking"
                      type="number"
                      value={config.harshBraking}
                      onChange={handleInputChange}
                      unit="g"
                      step="0.1"
                    />
                    <FormInput
                      label="Harsh Acceleration"
                      name="harshAcceleration"
                      type="number"
                      value={config.harshAcceleration}
                      onChange={handleInputChange}
                      unit="g"
                      step="0.1"
                    />
                  </div>
                </div>

                <div className="config-section-ParameterOverAir-Analog">
                  <h3 className="config-section-title-ParameterOverAir">
                    Analog & Digital I/O
                  </h3>
                  <div className="config-input-grid-ParameterOverAir">
                    <div>
                      <label
                        htmlFor="analogInput1"
                        className="form-input-label-ParameterOverAir"
                      >
                        Analog Input 1
                      </label>
                      <CustomSelect
                        id="analogInput1"
                        name="analogInput1"
                        value={config.analogInput1}
                        onChange={handleInputChange}
                        placeholder="Select Threshold"
                      >
                        <option value="40">40%</option>
                        <option value="55">55%</option>
                        <option value="70">70%</option>
                        <option value="85">85%</option>
                      </CustomSelect>
                    </div>
                    <div>
                      <label
                        htmlFor="analogInput2"
                        className="form-input-label-ParameterOverAir"
                      >
                        Analog Input 2
                      </label>
                      <CustomSelect
                        id="analogInput2"
                        name="analogInput2"
                        value={config.analogInput2}
                        onChange={handleInputChange}
                        placeholder="Select Threshold"
                      >
                        <option value="40">40%</option>
                        <option value="55">55%</option>
                        <option value="70">70%</option>
                        <option value="85">85%</option>
                      </CustomSelect>
                    </div>
                  </div>
                </div>
              </div>
              <div className="config-column-ParameterOverAir">
                <div className="config-section-ParameterOverAir">
                  <h3 className="config-section-title-ParameterOverAir">
                    Data Transmission Frequency
                  </h3>
                  <FormInput
                    label="Normal / Ignition ON"
                    name="dataTxNormal"
                    type="number"
                    value={config.dataTxNormal}
                    onChange={handleInputChange}
                    unit="seconds"
                  />
                  <FormInput
                    label="Sleep / Ignition OFF"
                    name="dataTxIgnitionOff"
                    type="number"
                    value={config.dataTxIgnitionOff}
                    onChange={handleInputChange}
                    unit="seconds"
                  />
                  <FormInput
                    label="Emergency State Duration"
                    name="emergencyDuration"
                    type="number"
                    value={config.emergencyDuration}
                    onChange={handleInputChange}
                    unit="minutes"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      <ActionModal
        isOpen={isResetModalOpen}
        onClose={() => setIsResetModalOpen(false)}
        onConfirm={handleResetDevice}
        title="Confirm Device Reset"
        confirmText="Confirm Reset"
        confirmClass="button-red-ParameterOverAir"
      >
        Are you sure you want to reset the device? This action is irreversible
        and will restore the device to its factory settings.
      </ActionModal>

      <ActionModal
        isOpen={isAssignModalOpen}
        onClose={() => setIsAssignModalOpen(false)}
        onConfirm={() => {
          setIsAssignModalOpen(false);
          proceedWithAssignment();
        }}
        title="Device Assignment Warning"
        confirmText="Re-assign Anyway"
        confirmClass="button-red-ParameterOverAir"
      >
        {assignModalMessage}
      </ActionModal>
    </div>
  );
}

export default ParameterOverAir;
